/* @indexer:no-export */
import * as React from 'react';
import './HelpIndicator.css';
import ButtonLabel from '../Buttons/ButtonLabel/ButtonLabel';
import IconButton from '../Buttons/IconButton/IconButton';
import Toggletip from '../Tips/Toggletip/Toggletip';
import QuestionMark from '../Icons/QuestionMark/QuestionMark';
import ThemeContext from '../ThemeContext';
export default function (_ref) {
  var label = _ref.label,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: 'dm'
  }, /*#__PURE__*/React.createElement(Toggletip, {
    i18n: i18n
  }, function (_ref2) {
    var ref = _ref2.ref,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(IconButton, {
      className: "_dm-button--help auto-help-indicator",
      ref: ref,
      onClick: events.onClick,
      onKeyDown: events.onKeyDown,
      onBlur: events.onBlur
    }, label && /*#__PURE__*/React.createElement(ButtonLabel, {
      i18n: label,
      hideLabel: true
    }), /*#__PURE__*/React.createElement(QuestionMark, {
      width: 12,
      height: 12,
      className: "_dm-icon--help-input"
    }));
  }));
}